/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerfollowflyerfineprint3Inputs */

const en_organizerfollowflyerfineprint3 = /** @type {(inputs: Organizerfollowflyerfineprint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan the code`)
};

const de_organizerfollowflyerfineprint3 = /** @type {(inputs: Organizerfollowflyerfineprint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code scannen`)
};

/**
* | output |
* | --- |
* | "Scan the code" |
*
* @param {Organizerfollowflyerfineprint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerfollowflyerfineprint3 = /** @type {((inputs?: Organizerfollowflyerfineprint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerfollowflyerfineprint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerfollowflyerfineprint3(inputs)
	return de_organizerfollowflyerfineprint3(inputs)
});
export { organizerfollowflyerfineprint3 as "organizerFollowFlyerFineprint" }